import axios from "axios";
import { server } from "../api";

const IndoorPositioningAlertConfig = {
  GetConfig: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/alert-config`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取警報設定失敗",
          data: null,
        }
      );
    }
  },

  UpdateConfig: async (machineID, fields) => {
    try {
      const response = await axios.put(
        `${server}indoor-positioning/${machineID}/alert-config`,
        fields,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新警報設定失敗",
          data: null,
        }
      );
    }
  },

  ResetConfig: async (machineID) => {
    try {
      const response = await axios.put(
        `${server}indoor-positioning/${machineID}/alert-config`,
        { reset: true },
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "重置警報設定失敗",
          data: null,
        }
      );
    }
  },
};

export default IndoorPositioningAlertConfig;
